<template>
<div class="AdminPanelServices page" v-if="$store.getters['auth/isAllowed']('can_view_admin_panel')">
  <BackBtn />
  <BreadCrumbs :items="breadcrumbs" />
  <div class=" d-flex align-center pb-4 mb-4">
    <h1 class="font-lg">Управление услугами</h1>
  </div>
  <div>
    <v-btn
      large
      class="AdminPanelServices__btn"
      color="white"
      outlined
      @click="goToAddService"
    >
      Добавить услугу
    </v-btn>
    <TableServices
      class="mt-2"
      @deleteService="showDlgDeleteService"
      @publishedService="showAcceptPublishedModal"
      @draftedService="showAcceptUnPublishedModal"
      @changeOrderService="changeOrderService"
    />
    <!--  Modals Window  -->

    <ModalWithAction
      :show-modal="showAcceptPublished"
      title="Подтвердите публикацию "
      accept-button="Опубликовать"
      text="Вы уверены, что хотите опубликовать услугу?"
      @closeModal="() => showAcceptPublished = false"
      @accept="publishedService"
    />
    <ModalWithAction
      :show-modal="showAcceptUnPublished"
      title="Подтвердите снятие "
      accept-button="Скрыть услугу"
      text="Вы уверены, что хотите скрыть услугу?"
      @closeModal="() => showAcceptUnPublished = false"
      @accept="draftedService"
    />
    <ModalSuccessDelete
      :show-dlg-delete="deleteSuccessServiceModal"
      :successText="'Услуга успешно удалена'"
      @closeModal="()=>deleteSuccessServiceModal = false"
    />
    <ModalDeleteService
      :service="deleteServiceItem"
      :show-dlg-delete="deleteServiceModal"
      @closeModal="hideDlgDeleteService"
      @acceptDelete="deleteService"
    />
  </div>
</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import TableServices from '@/components/admin-panel/TableServices.vue';
import ModalDeleteService from '@/components/admin-panel/Modal/ModalDeleteService.vue';
import ModalSuccessDelete from '@/components/admin-panel/Modal/ModalSuccessDelete.vue';
import ModalWithAction from '@/components/admin-panel/Modal/ModalWithAction.vue';

/**
 * Компонент: AdminPanelServices
 * Описание:
 */
export default {
  name: 'AdminPanelServices',
  components: {
    ModalWithAction, ModalSuccessDelete, ModalDeleteService, TableServices
  },

  props: {},

  data() {
    const deleteServiceModal = false;
    const deleteServiceItem = null;
    const deleteSuccessServiceModal = false;
    const showAcceptPublished = false;
    const showAcceptUnPublished = false;
    const activeActionService = null;
    return {
      deleteServiceModal,
      deleteServiceItem,
      deleteSuccessServiceModal,
      showAcceptPublished,
      showAcceptUnPublished,
      activeActionService,
    };
  },

  computed: {
    ...mapGetters({
      user: 'auth/user',
    }),
    breadcrumbs() {
      return [
        { title: 'Админка', url: '/admin-panel' },
        { title: 'Управление услугами', url: '' },
      ];
    },
  },

  watch: {},

  created() {
  },

  mounted() {
    this.getAllServices();
  },

  beforeDestroy() {
  },

  methods: {
    ...mapActions({
      deleteServiceStore: 'services/services/DELETE_SERVICE',
      GET_ALL_SERVICES: 'services/services/GET_ALL_SERVICES',
      PUBLISHED_SERVICES: 'services/services/PUBLISHED_SERVICE',
      UN_PUBLISHED_SERVICE: 'services/services/UN_PUBLISHED_SERVICE',
      CHANGE_ORDER_SERVICE: 'services/services/CHANGE_ORDER_SERVICE',
    }),
    goToAddService() {
      this.$router.push('/admin-panel/services/add');
    },
    showDlgDeleteService(item) {
      this.deleteServiceItem = item;
      this.deleteServiceModal = true;
    },
    hideDlgDeleteService() {
      this.deleteServiceItem = null;
      this.deleteServiceModal = false;
    },
    async getAllServices() {
      await this.GET_ALL_SERVICES();
    },
    async deleteService() {
      if (!this.$store.getters['auth/isAllowed']('can_view_admin_panel')) return;
      if (this.deleteServiceItem && this.deleteServiceItem.id) {
        try {
          const data = {
            id: this.deleteServiceItem.id,
          };
          await this.deleteServiceStore(data);
          await this.getAllServices();
          this.deleteServiceItem = null;
          this.deleteServiceModal = false;
          this.deleteSuccessServiceModal = true;
        } catch (error) {
          this.$toast.error('Ошибка, при попытке удалить услугу. Попробуйте позже', '', { position: 'topRight' });
        }
      } else {
        this.$toast.error('Ошибка, при попытке удалить услугу. Попробуйте позже', '', { position: 'topRight' });
      }
    },
    async publishedService() {
      if (!this.$store.getters['auth/isAllowed']('can_view_admin_panel')) return;
      try {
        const data = {
          id: this.activeActionService.id,
        };
        await this.PUBLISHED_SERVICES(data);
        await this.getAllServices();
        this.showAcceptPublished = false;
      } catch (error) {
        console.error(error);
      }
    },
    async draftedService() {
      if (!this.$store.getters['auth/isAllowed']('can_view_admin_panel')) return;
      try {
        const data = {
          id: this.activeActionService.id,
        };
        await this.UN_PUBLISHED_SERVICE(data);
        await this.getAllServices();
        this.showAcceptUnPublished = false;
      } catch (error) {
        console.error(error);
      }
    },
    async changeOrderService(item, value) {
      if (!this.$store.getters['auth/isAllowed']('can_view_admin_panel')) return;
      try {
        const data = {
          id: item.id,
          order: value,
        };
        await this.CHANGE_ORDER_SERVICE(data);
        await this.getAllServices();
      } catch (error) {
        console.error(error);
      }
    },
    showAcceptUnPublishedModal(service) {
      this.activeActionService = service;
      this.showAcceptUnPublished = true;
    },
    showAcceptPublishedModal(service) {
      this.activeActionService = service;
      this.showAcceptPublished = true;
    },
  },
};
</script>

<style scoped lang="scss">
.AdminPanelServices {

  & .AdminPanelServices__btn{
    background: var(--color-blue-500);
    border-radius: 6px;
    height: 100%;
    font-size: 16px;
    padding: 10px 16px;
    margin-left: 8px;
    ::v-deep span{
      line-height: 24px;
    }
  }
  /* Стили компонента */
}
</style>
